export const convertSecondsIntoMins = (seconds: string): string => {
  const secondsInt = parseInt(seconds, 10);
  const hours = Math.floor(secondsInt / 3600);
  const minutes = Math.floor((secondsInt % 3600) / 60);
  const remainingSeconds = secondsInt % 60;

  let result = '';

  if (hours > 0) {
    result += hours + ':';
  }

  if (minutes < 10) {
    result += hours > 0 ? '0' + minutes + ':' : minutes + ':';
  } else {
    result += minutes + ':';
  }

  if (remainingSeconds < 10) {
    result += '0' + remainingSeconds;
  } else {
    result += remainingSeconds;
  }

  return result;
};
